import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import axios from 'axios';

export const useLocationStore = defineStore('location', () => {
  const selectedLocation = ref(JSON.parse(localStorage.getItem('selectedLocation')) || null);
  const locations = ref([]);

  const setLocation = (location) => {
    selectedLocation.value = location;
  };

  const setLocations = (list) => {
    locations.value = list;
  };

  const resetLocation = () => {
    selectedLocation.value = null;
    localStorage.removeItem('selectedLocation');
  };
  

  const fetchLocations = async () => {
    if (locations.value.length > 0) return;

    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(`${process.env.VUE_APP_API_URL}masterdata/get_locations/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLocations(response.data);
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  watch(selectedLocation, (val) => {
    if (val) {
      localStorage.setItem('selectedLocation', JSON.stringify(val));
    } else {
      localStorage.removeItem('selectedLocation');
    }
  });

  return {
    selectedLocation,
    locations,
    setLocation,
    setLocations,
    fetchLocations,
    resetLocation, // ✅ now available for logout
  };
});
